<div class="p-dialog-content__dynamic">
  <app-vehicle-form
    [isInsideContract]="true"
    [doNotTakeIdFromUrl]="true"
    [isModalFooter]="true"
    (onCancelCreation)="cancelClicked()"
    (onSubmit)="onSubmit($event)"
  ></app-vehicle-form>
  <app-ngx-loader [loading]="isLoading"></app-ngx-loader>
</div>
